import { render, staticRenderFns } from "./HotMember.vue?vue&type=template&id=b490e428&scoped=true"
import script from "./HotMember.vue?vue&type=script&lang=ts"
export * from "./HotMember.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./HotMember.vue?vue&type=style&index=0&id=b490e428&prod&scoped=true&lang=scss")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "b490e428",
  "52ae9f12"
  
)

export default component.exports